export const BASE_URL = "https://app-dev.admind.ai/";

const getUrl = ()=>{
    // In development on Replit, use relative URL to same origin
    if (typeof window !== 'undefined' && window.location.hostname.includes('replit')) {
        return '/api/';
    }
    if (process.env.REACT_APP_DEBUG==='1'){
        return process.env.REACT_APP_URL || 'http://localhost:8000/'
    }else{
        return BASE_URL
    }
}
const backEnd = {
    url: getUrl(),
};
    
export default backEnd;
